<mat-card>
  <mat-card-title>Settings</mat-card-title>
  <mat-card-content>
    @let loaded = preferencesSelectors.finishedLoading | select:false;
    @let availableSmsOptions = currentPatronSelectors.eligibleSmsNumberOptions | select:[];
    @let enableSmsField = availableSmsOptions.length > 0;

    <div mxHiddenUntilLoaded [reveal]="loaded" class="flex flex-col lg:flex-row gap-10">
      <div class="order-1 flex flex-col w-full lg:w-3/4 gap-5">
        <p class="text-headline-small">Notification Preferences</p>
        <!-- Top Input Row -->
        <div class="flex flex-col gap-y-2">
          <div class="flex flex-col gap-y-4 md:flex-row md:gap-x-4 w-full">
            <mx-input-form-field fieldName="notificationEmail" [formGroup]="formGroup" class="w-full md:basis-[40%] no-bottom-margin"/>
            <div class="flex md:flex-row gap-4 w-full md:basis-[60%]"
                 [matTooltip]="enableSmsField ? '' : 'Add a mobile number to your profile to enable this option'" matTooltipPosition="above">
              <mx-select-form-field fieldName="phoneSms" [formGroup]="formGroup" [options]="availableSmsOptions" [enabled]="enableSmsField"
                                    overrideLabel="SMS Notification" class="basis-2/3 md:min-w-[12rem] no-bottom-margin"/>
              @if (phoneOptionEnabled) {
                <div class="basis-1/3 min-w-[6.25rem] text-body-medium flex flex-col gap-2">
                  <p>Phone Number</p>
                  <p>{{ currentPatronSelectors.phoneCall | select }}</p>
                </div>
              }
            </div>
          </div>

          <!-- SMS Notifications Agreement -->
          @if (smsNumberSelected) {
            <div class="flex flex-row gap-3 w-full items-start mb-3">
              <px-sms-terms-checkbox fieldName="smsTermsAccepted" [formGroup]="formGroup" [isTermsAcceptedValid]="isTermsAcceptedValid"/>
            </div>
          }
        </div>


        <ng-container *ngTemplateOutlet="notificationSection; context: {
                                  title: 'Account Related',
                                  description: 'Notices related to claims, charges, or account status.',
                                  fieldName: 'accountNotifications'
                                }"/>

        <ng-container *ngTemplateOutlet="notificationSection; context: {
                                  title: 'Card Expiration',
                                  description: 'Library card expiration date notices.',
                                  fieldName: 'expirationNotifications'
                                }"/>

        <ng-container *ngTemplateOutlet="notificationSection; context: {
                                  title: 'Renewals',
                                  description: 'Items that have been renewed.',
                                  fieldName: 'renewNotifications'
                                }"/>

        <ng-container *ngTemplateOutlet="notificationSection; context: {
                                  title: 'Hold Related',
                                  description: 'Holds ready for pickup, cancelled, or expiring holds.',
                                  fieldName: 'holdNotifications',
                                  showExtendedOptions: true
                                }"/>

        <ng-container *ngTemplateOutlet="notificationSection; context: {
                                  title: 'Receipts',
                                  description: 'Check out or payment receipts of any kind.',
                                  fieldName: 'receiptNotifications'
                                }"/>


        <ng-container *ngTemplateOutlet="notificationSection; context: {
                                  title: 'Notices',
                                  description: 'Items due back soon or are overdue.',
                                  fieldName: 'noticeNotifications'
                                }"/>

        <ng-container *ngTemplateOutlet="notificationSection; context: {
                                  title: 'Item Requests',
                                  description: 'Updates related to active item requests.',
                                  fieldName: 'itemRequestNotifications'
                                }"/>

        <mx-filled-button label="Save Changes" [enabled]="formGroup.valid" (click)="onClickSaveButton()" class="self-end"/>
      </div>

      <mat-divider vertical class="hidden self-stretch lg:block lg:order-2"/>

      <!-- Dependents, Linked Accounts, Borrowing History, One Click Holds -->
      <div class="order-2 flex flex-col gap-2 md:gap-8 w-full md:basis-1/2 lg:order-3 lg:basis-1/4 lg:min-w-[15.5rem]">
        <div>
          <p class="text-headline-small">Borrowing History</p>
          <mx-slide-toggle-form-field fieldName="optInReadingHistory" overrideLabel="Save Borrowing History" [formGroup]="quickTogglesFormGroup"
                                      labelClasses="text-title-medium" class="pl-4 pr-0 pt-3"/>
        </div>
        <div>
          <p class="text-headline-small">One Click Holds</p>
          <p class="text-body-medium pt-1">
            Skip the step of selecting a pickup location when you place a hold. We'll use your set pickup location as the default.
          </p>
          <mx-slide-toggle-form-field fieldName="oneClickHoldsEnabled" overrideLabel="One Click Holds" [formGroup]="quickTogglesFormGroup"
                                      labelClasses="text-title-medium" class="pl-4 pr-0 pt-3"/>
        </div>
      </div>
    </div>

    <ng-template #notificationSection let-title="title" let-description="description" let-fieldName="fieldName" let-showExtendedOptions="showExtendedOptions">
      <mx-form-row class="text-on-surface items-start justify-between gap-x-8">
        <div class="flex flex-col gap-1 basis-2/3 max-w-[23rem]">
          <p class="text-title-medium">{{ title }}</p>
          <p class="text-body-medium">{{ description }}</p>
        </div>
        <mx-select-form-field [fieldName]="fieldName" overrideLabel="Preference" [formGroup]="formGroup" class="basis-1/3 min-w-[8.5rem] no-bottom-margin"
                              [options]="showExtendedOptions
                                 ? EXTENDED_PATRON_NOTIFICATION_PREFERENCE_SELECT_OPTIONS
                                 : STANDARD_PATRON_NOTIFICATION_PREFERENCE_SELECT_OPTIONS"
                              [includeUndefinedOption]="false"/>
      </mx-form-row>
    </ng-template>
  </mat-card-content>
</mat-card>
